module.exports = __webpack_public_path__ + "img/huiyu-back-cp.d9a8cca2.png";